<template>
  <div>

    <div v-if="group_id === 1 || group_id === 2 || group_id === 7 || group_id === 8">
      <!-- 顶部统计卡片 - 简洁风格 -->
      <Row :gutter="16" style="margin-top: 20px">
        <Col span="6">
          <Card dis-hover class="stat-card stat-blue">
            <div class="stat-content">
              <div class="stat-value">{{ info.total_order_num || 0 }}</div>
              <div class="stat-label">总订单数</div>
              <div class="stat-yesterday">
                <span class="label">昨日：</span>
                <span class="value">{{ info.yesterday_total_order_num !== undefined ? info.yesterday_total_order_num : 0 }}</span>
              </div>
              <div class="stat-icon">
                <Icon type="ios-document" />
              </div>
            </div>
          </Card>
        </Col>
        
        <Col span="6">
          <Card dis-hover class="stat-card stat-green" @click.native="goToTodayOrders">
            <div class="stat-content">
              <div class="stat-value">{{ info.today_order_num || 0 }}</div>
              <div class="stat-label">今日订单</div>
              <div class="stat-yesterday">
                <span class="label">昨日：</span>
                <span class="value">{{ info.yesterday_order_num !== undefined ? info.yesterday_order_num : 0 }}</span>
              </div>
              <div class="stat-icon">
                <Icon type="ios-calendar" />
              </div>
            </div>
          </Card>
        </Col>
        
        <Col span="6">
          <Card dis-hover class="stat-card stat-success">
            <div class="stat-content">
              <div class="stat-value">{{ info.today_litre_num || 0 }} L</div>
              <div class="stat-label">今日加注</div>
              <div class="stat-yesterday">
                <span class="label">昨日：</span>
                <span class="value">{{ info.yesterday_litre_num !== undefined ? info.yesterday_litre_num : 0 }} L</span>
              </div>
              <div class="stat-icon">
                <Icon type="md-trending-up" />
              </div>
            </div>
          </Card>
        </Col>
        
        <Col span="6">
          <Card dis-hover class="stat-card stat-warning">
            <div class="stat-content">
              <div class="stat-value">{{ info.today_driver_num || 0 }}</div>
              <div class="stat-label">今日新增司机</div>
              <div class="stat-yesterday">
                <span class="label">昨日：</span>
                <span class="value">{{ info.yesterday_driver_num !== undefined ? info.yesterday_driver_num : 0 }}</span>
              </div>
              <div class="stat-icon">
                <Icon type="ios-people" />
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      <Row :gutter="16" style="margin-top: 16px">
        <Col span="6">
          <Card dis-hover class="stat-card stat-purple">
            <div class="stat-content">
              <div class="stat-value">{{ info.station_num || 0 }}</div>
              <div class="stat-label">油站数量</div>
              <div class="stat-icon">
                <Icon type="ios-pin" />
              </div>
            </div>
          </Card>
        </Col>
        
        <Col span="6">
          <Card dis-hover class="stat-card stat-cyan">
            <div class="stat-content">
              <div class="stat-value">{{ info.unsettle_litre_num || 0 }} L</div>
              <div class="stat-label">待结算数量</div>
              <div class="stat-icon">
                <Icon type="ios-fuel" />
              </div>
            </div>
          </Card>
        </Col>
        
        <Col span="6">
          <Card dis-hover class="stat-card stat-orange">
            <div class="stat-content">
              <div class="stat-value">{{ info.wait_settle_order || 0 }}</div>
              <div class="stat-label">待结算订单</div>
              <div class="stat-icon">
                <Icon type="ios-time" />
              </div>
            </div>
          </Card>
        </Col>
        
        <Col span="6">
          <Card dis-hover class="stat-card stat-red">
            <div class="stat-content">
              <div class="stat-value">¥{{ info.wait_settle_amount || 0 }}</div>
              <div class="stat-label">待结算金额</div>
              <div class="stat-icon">
                <Icon type="ios-cash" />
              </div>
            </div>
          </Card>
        </Col>
      </Row>
      <Card dis-hover title="电话订单" style="margin-top: 20px" v-show="false">
        <Row :gutter="16">
          <Col span="6">
            <Card  @click.native="turnToPage('电话收入')">
              <p slot="title">电话推广数量</p>
              <p>{{ info.promote_order_num }}</p>
            </Card>
          </Col>
          <Col span="6">
            <Card  @click.native="turnToPage('电话收入')">
              <p slot="title">电话推广收入</p>
              <p>{{ info.promote_income }}</p>
            </Card>
          </Col>
          <Col span="6">
            <Card  @click.native="turnToPage('电话收入')">
              <p slot="title">今日推广数量</p>
              <p>{{ info.promote_today_order_num }}</p>
            </Card>
          </Col>
          <Col span="6">
            <Card  @click.native="turnToPage('电话收入')">
              <p slot="title">今日推广收入</p>
              <p>{{ info.promote_today_income }}</p>
            </Card>
          </Col>
        </Row>
      </Card>

      <!-- 中间三列布局 -->
      <Row :gutter="16" style="margin-top: 16px">
        <!-- 左侧：加油站排行 -->
        <Col span="8">
          <Card dis-hover class="ranking-list-card">
            <div slot="title" class="card-title-with-badge">
              <span class="title-text">加油站排行</span>
              <Badge :count="5" type="warning" />
            </div>
            <pageTable ref="oilRangeTable"
                       :showPage="false"
                       :searchData="oilRangeForm"
                       :tableTitle="oilRangeColumn"
                       tableApi="admin/gas/oilRange"
                       :onSortChange="oilRangeSortChange"
                       height="400"
            >
              <template v-slot:searchFormItem>
                <FormItem prop="searchDay">
                  <DatePicker 
                    v-model="oilRangeForm.searchDay" 
                    type="date" 
                    placeholder="选择日期" 
                    :options="dateOptions"
                    style="width: 200px"
                  ></DatePicker>
                </FormItem>
              </template>
            </pageTable>
          </Card>
        </Col>
        
        <!-- 中间：车队加油排行 -->
        <Col span="8">
          <Card dis-hover class="ranking-list-card">
            <div slot="title" class="card-title-with-badge">
              <span class="title-text">车队加油排行</span>
              <Badge :count="10" type="info" />
            </div>
            <pageTable ref="companyOilRangeTable"
                       :showPage="false"
                       :searchData="companyOilRangeForm"
                       :tableTitle="companyOilRangeColumn"
                       tableApi="admin/gas/companyOilRange"
                       :onSortChange="companyOilRangeSortChange"
                       height="400"
            >
              <template v-slot:searchFormItem>
                <FormItem prop="searchDay">
                  <DatePicker 
                    v-model="companyOilRangeForm.searchDay" 
                    type="date" 
                    placeholder="选择日期"
                    :options="dateOptions"
                    style="width: 200px"
                  ></DatePicker>
                </FormItem>
              </template>
            </pageTable>
          </Card>
        </Col>
        
        <!-- 右侧：图表 - TOP10占比 -->
        <Col span="8">
          <Card dis-hover class="chart-card ranking-list-card">
            <div slot="title" class="card-title-with-badge">
              <span class="title-text">加油站占比</span>
            </div>
            <div ref="oilRangeChart" class="chart-container"></div>
          </Card>
        </Col>
      </Row>

      <!-- 底部两行 -->
      <Row :gutter="16" style="margin-top: 16px">
        <!-- 第一行：车队TOP10对比 -->
        <Col span="12">
          <Card dis-hover class="chart-card">
            <div slot="title" class="card-title-with-badge">
              <span class="title-text">车队TOP10对比</span>
            </div>
            <div ref="companyOilRangeChart" style="width: 100%; height: 350px;"></div>
          </Card>
        </Col>
        
        <!-- 第二行：库存状态分布 -->
        <Col span="12">
          <Card dis-hover class="chart-card" @click.native="scrollToStockMonitor">
            <div slot="title" class="card-title-with-badge">
              <span class="title-text">库存状态分布</span>
            </div>
            <div ref="stockTrendChart" style="width: 100%; height: 350px;"></div>
          </Card>
        </Col>
      </Row>

      <!-- 订单趋势 -->
      <Row :gutter="16" style="margin-top: 16px">
        <Col span="24">
          <Card dis-hover class="chart-card">
            <div slot="title" class="card-title-with-badge">
              <span class="title-text">订单趋势</span>
              <div class="trend-filters">
                <Select
                  v-model="trendCompanyId"
                  filterable
                  clearable
                  placeholder="全部车队"
                  style="width: 220px"
                  @on-change="getTrend"
                >
                  <Option v-for="item in companyOptions" :key="item.company_id" :value="item.company_id" :label="item.company_name">{{ item.company_name }}</Option>
                </Select>
                <DatePicker
                  v-model="trendDateRange"
                  type="daterange"
                  placement="bottom-end"
                  :options="trendDatePickerOptions"
                  :clearable="false"
                  placeholder="选择日期范围"
                  style="width: 260px"
                  @on-change="handleTrendDateChange"
                ></DatePicker>
              </div>
            </div>

            <!-- 汇总统计 -->
            <div v-if="trendSummary" class="trend-summary">
              <div class="trend-summary-item">
                <div class="ts-label">总订单数</div>
                <div class="ts-value ts-blue">{{ trendSummary.order_num || 0 }}</div>
              </div>
              <div class="trend-summary-item">
                <div class="ts-label">总加注量(L)</div>
                <div class="ts-value ts-green">{{ formatLitre(trendSummary.litre_num) }}</div>
              </div>
              <div class="trend-summary-item">
                <div class="ts-label">总金额(元)</div>
                <div class="ts-value ts-orange">¥ {{ formatMoney(trendSummary.total_price) }}</div>
              </div>
              <div class="trend-summary-item">
                <div class="ts-label">日均订单 / 加注(L)</div>
                <div class="ts-value ts-purple">
                  <span>{{ avgDailyOrder }}</span>
                  <span class="ts-split">/</span>
                  <span>{{ avgDailyLitre }}</span>
                </div>
              </div>
            </div>

            <div v-show="trendLoading" style="text-align: center; padding: 80px 0;">
              <Spin size="large"></Spin>
            </div>
            <div v-show="!trendLoading" ref="trendChart" style="width: 100%; height: 350px;"></div>
          </Card>
        </Col>
      </Row>

      <!-- 站点库存监控 - 全宽 -->
      <Row :gutter="16" style="margin-top: 16px">
        <Col span="24">
          <Card dis-hover class="stock-monitor-card">
            <div slot="title" class="card-title-with-badge">
              <span class="title-text">站点库存监控</span>
              <Badge :count="lowStockCount" v-if="lowStockCount > 0" />
            </div>
            <pageTable ref="stockStationTable"
                       :showSearchForm="false"
                       :tableTitle="stockStationColumn"
                       tableApi="admin/gas/stockStation"
                       :defaultPageSize="10"
                       :pageSizeOptions="[10, 20, 50]"
                       height="350"
            >
            </pageTable>
          </Card>
        </Col>
      </Row>

    </div>

    <template v-if="group_id === 4">
      <home-company :home-info="info"></home-company>
    </template>

    <Drawer title="库存记录" width="900"
            :value="isShowStockDrawer"
            :mask-closable="true"
            @on-close="isShowStockDrawer=false">
      <stockLog :stationID="stockStationID" v-if="isShowStockDrawer"></stockLog>
    </Drawer>

    <!-- 车队列表弹窗 -->
    <Modal
      v-model="showCompanyModal"
      title="车队加油列表"
      :width="modalWidth"
      :footer-hide="true"
      :mask-closable="true"
    >
      <div v-if="selectedStation" style="margin-bottom: 16px; padding: 12px; background: #f8f8f9; border-radius: 4px; border-left: 3px solid #2d8cf0;">
        <strong>站点名称：</strong>{{ selectedStation.station_name }} <strong>价格：</strong>{{ selectedStation.price ? parseFloat(selectedStation.price).toFixed(2) + ' 元/L' : '暂无数据' }}
        <strong style="margin-left: 30px;">利润总和：</strong><span :style="{ fontWeight: 'bold', fontSize: '16px', color: companyProfitTotal >= 0 ? '#19be6b' : '#ed4014' }">¥{{ companyProfitTotal.toFixed(2) }}</span>
      </div>
      <Table
        :columns="companyListColumn"
        :data="companyListData"
        :loading="companyListLoading"
        :maxHeight="tableMaxHeight"
        border
        stripe
      ></Table>
    </Modal>

    <!-- 站点列表弹窗 -->
    <Modal
      v-model="showStationModal"
      title="站点加油列表"
      :width="modalWidth"
      :footer-hide="true"
      :mask-closable="true"
    >
      <div v-if="selectedCompany" style="margin-bottom: 16px; padding: 12px; background: #f8f8f9; border-radius: 4px; border-left: 3px solid #2d8cf0;">
        <strong>车队名称：</strong>{{ selectedCompany.company_name }}
        <strong style="margin-left: 30px;">利润总和：</strong><span :style="{ fontWeight: 'bold', fontSize: '16px', color: stationProfitTotal >= 0 ? '#19be6b' : '#ed4014' }">¥{{ stationProfitTotal.toFixed(2) }}</span>
      </div>
      <Table
        :columns="stationListColumn"
        :data="stationListData"
        :loading="stationListLoading"
        :maxHeight="tableMaxHeight"
        border
        stripe
      ></Table>
    </Modal>
  </div>


</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import stockLog from "./stockLog";
  import HomeCompany from "./homeCompany";
  import * as echarts from 'echarts';
  export default {
    name: "home",
    components:{HomeCompany, pageTable,stockLog},
    data(){
      return {
        info:{},
        group_id:0,
        isShowStockDrawer:false,
        stockStationID:0,
        lowStockCount: 0, // 低库存站点数量
        // 订单趋势（默认近7天日期范围）
        trendDateRange: (() => {
          const end = new Date();
          const start = new Date();
          start.setDate(start.getDate() - 6);
          return [start, end];
        })(),
        trendRangeDays: 7, // 当前查询区间实际天数（接口返回，用于日均计算）
        // 日期快捷选项（经 options 透传给面板）
        trendDatePickerOptions: {
          shortcuts: [
            {
              text: '近7天',
              value: () => {
                const end = new Date();
                const start = new Date();
                start.setDate(start.getDate() - 6);
                return [start, end];
              }
            },
            {
              text: '近14天',
              value: () => {
                const end = new Date();
                const start = new Date();
                start.setDate(start.getDate() - 13);
                return [start, end];
              }
            },
            {
              text: '近30天',
              value: () => {
                const end = new Date();
                const start = new Date();
                start.setDate(start.getDate() - 29);
                return [start, end];
              }
            },
            {
              text: '近90天',
              value: () => {
                const end = new Date();
                const start = new Date();
                start.setDate(start.getDate() - 89);
                return [start, end];
              }
            }
          ]
        },
        trendCompanyId: '',
        companyOptions: [],
        trendSummary: null,
        trendLoading: false,
        // 车队列表弹窗
        showCompanyModal: false,
        selectedStation: null,
        companyListData: [],
        companyListLoading: false,
        modalWidth: '70%', // 弹窗宽度，自适应屏幕的70%
        tableMaxHeight: 500, // 弹窗内表格最大高度(px)，自适应屏幕高度
        companyListColumn: [
          {title: '排名', key: 'rank', width: 90, align: "center", render: (h, params) => {
            const rank = params.index + 1;
            let color = '#808695';
            let bgColor = '#f8f8f9';
            let icon = '';
            
            if (rank === 1) {
              color = '#fff';
              bgColor = '#ff9900';
              icon = '🥇';
            } else if (rank === 2) {
              color = '#fff';
              bgColor = '#a0a0a0';
              icon = '🥈';
            } else if (rank === 3) {
              color = '#fff';
              bgColor = '#cd7f32';
              icon = '🥉';
            }
            
            return h('div', {
              style: {
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '50px',
                height: '28px',
                borderRadius: '14px',
                backgroundColor: bgColor,
                color: color,
                fontWeight: 'bold',
                fontSize: '13px',
                boxShadow: rank <= 3 ? '0 2px 4px rgba(0,0,0,0.1)' : 'none'
              }
            }, rank <= 3 ? `${icon} ${rank}` : rank);
          }},
          {title: '车队名称', key: 'company_name', align: "left", minWidth: 180, render: (h, params) => {
            return h('div', {
              style: {
                display: 'flex',
                alignItems: 'center',
                fontWeight: params.index < 3 ? '600' : 'normal',
                color: params.index < 3 ? '#2d8cf0' : 'inherit'
              }
            }, [
              params.index < 3 ? h('Icon', {
                props: { type: 'ios-trophy', size: 14 },
                style: { color: '#2d8cf0', marginRight: '4px' }
              }) : null,
              h('span', params.row.company_name)
            ]);
          }},
          {title: '订单数', key: 'order_count', align: "center", width: 120},
          {title: '加油量(L)', key: 'total_litre', align: "center", width: 150, render: (h, params) => {
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: '#19be6b',
                fontSize: '15px'
              }
            }, parseFloat(params.row.total_litre).toLocaleString() + ' L');
          }},
          {title: '总金额(元)', key: 'total_amount', align: "center", width: 150, render: (h, params) => {
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: '#ff9900'
              }
            }, '¥' + parseFloat(params.row.total_amount).toLocaleString());
          }},
          {title: '单价(元/L)', key: 'price', align: "center", width: 120, render: (h, params) => {
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: '#2d8cf0'
              }
            }, params.row.price.toFixed(2));
          }},
          {title: '价格差(元/L)', key: 'price_diff', align: "center", width: 120, render: (h, params) => {
            const stationPrice = parseFloat(this.selectedStation && this.selectedStation.price);
            const companyPrice = parseFloat(params.row.price);
            const diff = (!isNaN(stationPrice) && !isNaN(companyPrice)) ? companyPrice - stationPrice : 0;
            const color = diff > 0 ? '#19be6b' : diff < 0 ? '#ed4014' : '#808695';
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: color
              }
            }, (diff > 0 ? '+' : '') + diff.toFixed(2));
          }},
          {title: '利润(元)', key: 'profit', align: "center", width: 150, render: (h, params) => {
            // 优先使用接口返回的 profit 字段，否则前端计算（单价 - 站点价格）× 升数
            let profit = parseFloat(params.row.profit);
            if (isNaN(profit)) {
              const stationPrice = parseFloat(this.selectedStation && this.selectedStation.price);
              const companyPrice = parseFloat(params.row.price);
              const diff = (!isNaN(stationPrice) && !isNaN(companyPrice)) ? companyPrice - stationPrice : 0;
              profit = diff * parseFloat(params.row.total_litre || 0);
            }
            const color = profit > 0 ? '#19be6b' : profit < 0 ? '#ed4014' : '#808695';
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: color
              }
            }, '¥' + profit.toFixed(2));
          }}
        ],
        // 站点列表弹窗
        showStationModal: false,
        selectedCompany: null,
        stationListData: [],
        stationListLoading: false,
        stationListColumn: [
          {title: '排名', key: 'rank', width: 90, align: "center", render: (h, params) => {
            const rank = params.index + 1;
            let color = '#808695';
            let bgColor = '#f8f8f9';
            let icon = '';
            
            if (rank === 1) {
              color = '#fff';
              bgColor = '#ff9900';
              icon = '🥇';
            } else if (rank === 2) {
              color = '#fff';
              bgColor = '#a0a0a0';
              icon = '🥈';
            } else if (rank === 3) {
              color = '#fff';
              bgColor = '#cd7f32';
              icon = '🥉';
            }
            
            return h('div', {
              style: {
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '50px',
                height: '28px',
                borderRadius: '14px',
                backgroundColor: bgColor,
                color: color,
                fontWeight: 'bold',
                fontSize: '13px',
                boxShadow: rank <= 3 ? '0 2px 4px rgba(0,0,0,0.1)' : 'none'
              }
            }, rank <= 3 ? `${icon} ${rank}` : rank);
          }},
          {title: '站点名称', key: 'gas_name', align: "left", minWidth: 200, render: (h, params) => {
            return h('div', {
              style: {
                display: 'flex',
                alignItems: 'center',
                fontWeight: params.index < 3 ? '600' : 'normal',
                color: params.index < 3 ? '#2d8cf0' : 'inherit'
              }
            }, [
              params.index < 3 ? h('Icon', {
                props: { type: 'ios-pin', size: 14 },
                style: { color: '#7367f0', marginRight: '4px' }
              }) : null,
              h('span', params.row.gas_name)
            ]);
          }},
          {title: '订单数', key: 'order_count', align: "center", width: 120},
          {title: '加油量(L)', key: 'total_litre', align: "center", width: 150, render: (h, params) => {
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: '#19be6b',
                fontSize: '15px'
              }
            }, parseFloat(params.row.total_litre).toLocaleString() + ' L');
          }},
          {title: '总金额(元)', key: 'total_amount', align: "center", width: 150, render: (h, params) => {
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: '#ff9900'
              }
            }, '¥' + parseFloat(params.row.total_amount).toLocaleString());
          }},
          {title: '车队单价(元/L)', key: 'price', align: "center", width: 120, render: (h, params) => {
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: '#2d8cf0'
              }
            }, params.row.price.toFixed(2));
          }},
          {title: '站点单价(元/L)', key: 'gas_price', align: "center", width: 120, render: (h, params) => {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#2d8cf0'
                }
              }, params.row.gas_price.toFixed(2));
            }},
          {title: '价格差(元/L)', key: 'price_diff', align: "center", width: 120, render: (h, params) => {
            const gasPrice = parseFloat(params.row.gas_price);
            const companyPrice = parseFloat(params.row.price);
            const diff = (!isNaN(gasPrice) && !isNaN(companyPrice)) ? companyPrice - gasPrice : 0;
            const color = diff > 0 ? '#19be6b' : diff < 0 ? '#ed4014' : '#808695';
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: color
              }
            }, (diff > 0 ? '+' : '') + diff.toFixed(2));
          }},
          {title: '利润(元)', key: 'profit', align: "center", width: 150, render: (h, params) => {
            // 优先使用接口返回的 profit 字段，否则前端计算（车队单价 - 站点单价）× 升数
            let profit = parseFloat(params.row.profit);
            if (isNaN(profit)) {
              const gasPrice = parseFloat(params.row.gas_price);
              const companyPrice = parseFloat(params.row.price);
              const diff = (!isNaN(gasPrice) && !isNaN(companyPrice)) ? companyPrice - gasPrice : 0;
              profit = diff * parseFloat(params.row.total_litre || 0);
            }
            const color = profit > 0 ? '#19be6b' : profit < 0 ? '#ed4014' : '#808695';
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: color
              }
            }, '¥' + profit.toFixed(2));
          }}
        ],
        // 图表实例
        oilRangeChart: null,
        companyOilRangeChart: null,
        stockTrendChart: null,
        trendChart: null,
        // 模拟数据（用于演示图表效果）
        mockOilRangeData: [
          { station_name: '中石化北京朝阳站', litre_num: 45680 },
          { station_name: '中石油上海浦东站', litre_num: 38920 },
          { station_name: '壳牌广州天河站', litre_num: 32150 },
          { station_name: '中海油深圳南山站', litre_num: 28760 },
          { station_name: '道达尔杭州西湖站', litre_num: 24390 }
        ],
        mockCompanyRangeData: [
          { company_name: '顺丰物流车队', litre_num: 52340 },
          { company_name: '京东运输车队', litre_num: 48760 },
          { company_name: '德邦快递车队', litre_num: 42180 },
          { company_name: '中通物流车队', litre_num: 38920 },
          { company_name: '圆通速递车队', litre_num: 35670 },
          { company_name: '韵达运输车队', litre_num: 31240 },
          { company_name: '申通物流车队', litre_num: 28560 },
          { company_name: '极兔速递车队', litre_num: 24890 },
          { company_name: '百世快运车队', litre_num: 21340 },
          { company_name: '安能物流车队', litre_num: 18760 }
        ],
        mockStockData: [
          { gas_name: '中石化朝阳站', litre_balance: 15000, warn_threshold: 10000 },
          { gas_name: '中石油浦东站', litre_balance: 8500, warn_threshold: 10000 },
          { gas_name: '壳牌天河站', litre_balance: 12000, warn_threshold: 8000 },
          { gas_name: '中海油南山站', litre_balance: 3500, warn_threshold: 8000 },
          { gas_name: '道达尔西湖站', litre_balance: 9800, warn_threshold: 10000 },
          { gas_name: '中石化海淀站', litre_balance: 6200, warn_threshold: 12000 },
          { gas_name: '中石油黄浦站', litre_balance: 18000, warn_threshold: 15000 },
          { gas_name: '壳牌越秀站', litre_balance: 4500, warn_threshold: 10000 },
          { gas_name: '中海油福田站', litre_balance: 11000, warn_threshold: 9000 },
          { gas_name: '道达尔上城站', litre_balance: 2800, warn_threshold: 8000 }
        ],
        stockStationColumn:[
          {title: '油站名称',key: 'gas_name',align: "left",minWidth: 150, render: (h, params) => {
            return h('div', {
              style: {
                display: 'flex',
                alignItems: 'center',
                fontWeight: '500'
              }
            }, [
              h('Icon', {
                props: { type: 'ios-pin', size: 16 },
                style: { color: '#7367f0', marginRight: '6px' }
              }),
              h('span', params.row.gas_name)
            ]);
          }},
          {title: '剩余数量(L)',key: 'litre_balance',align: "center",width: 300,render:(h,params)=>{
            const isLow = params.row.litre_balance < params.row.warn_threshold;
            const percentage = params.row.warn_threshold > 0 ? Math.min((params.row.litre_balance / params.row.warn_threshold * 100), 100).toFixed(0) : 100;
            let content = [];
            
            // 进度条背景
            content.push(h('div', {
              style: {
                width: '100%',
                marginBottom: '8px'
              }
            }, [
              h('Progress', {
                props: {
                  percent: parseFloat(percentage),
                  strokeColor: isLow ? '#ed4014' : percentage < 50 ? '#ff9900' : '#19be6b',
                  strokeWidth: 10,
                  hideInfo: true
                }
              })
            ]));
            
            // 数量和编辑按钮
            const numberAndEdit = h('div', {
              style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }
            }, [
              isLow ? h('Icon', {
                props: { type: 'ios-alert', size: 18 },
                style: { color: '#ed4014' }
              }) : null,
              h('a',{
                style:{
                  color: isLow ? '#ed4014' : '#2d8cf0',
                  fontWeight: isLow ? 'bold' : '500',
                  fontSize: isLow ? '16px' : '14px',
                  textDecoration: 'none'
                },
                on:{
                  click:()=>{
                    this.isShowStockDrawer=true;
                    this.stockStationID = params.row.station_id
                  }
                }
              }, params.row.litre_balance.toLocaleString() + ' L'),
              
              // 编辑按钮
              params.row.$isEdit ? h('div', {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  marginLeft: '8px'
                }
              }, [
                h('InputNumber',{
                  props:{value:params.row.edit_litre_balance || params.row.litre_balance,"controls-outside":true,step:100,size:'small'},
                  style:{width: '100px'},
                  on:{
                    input:(val)=>{
                      this.$set(params.row,'edit_litre_balance',val)
                    }
                  }
                }),
                h('Button', {
                  props: { type: 'success', size: 'small', icon: 'md-checkmark' },
                  on: { click: () => { this.editLitreBalance(params.row); } }
                }),
                h('Button', {
                  props: { type: 'default', size: 'small', icon: 'md-close' },
                  on: { click: () => { this.$set(params.row,'$isEdit',false); } }
                })
              ]) : h('Button', {
                props: { type: 'primary', size: 'small', icon: 'ios-create', ghost: true },
                style: { marginLeft: '8px' },
                on: { click: () => { this.$set(params.row,'$isEdit',true); } }
              })
            ]);
            
            content.push(numberAndEdit);
            return h('div', content);
          }},
          {title: '预警阈值(L)',key: 'warn_threshold',align: "center",width: 280,render:(h,params)=>{
              if (params.row.$isEditThreshold){
                return h('div',{
                  style:{display:'flex',alignItems:'center',justifyContent:'center',gap:'8px'}
                },[
                  h('InputNumber',{
                    props:{value:params.row.warn_threshold,size:'small',min:0,step:100},
                    style:{width:'120px'},
                    on:{
                      input:(val)=>{
                        this.$set(params.row,'warn_threshold',val)
                      }
                    }
                  }),
                  h('Button', {
                    props: { type: 'success', size: 'small', icon: 'md-checkmark' },
                    on: { click: () => { this.editWarnThreshold(params.row); } }
                  }),
                  h('Button', {
                    props: { type: 'default', size: 'small', icon: 'md-close' },
                    on: { click: () => { this.$set(params.row,'$isEditThreshold',false); } }
                  })
                ])
              }else{
                const isLow = params.row.litre_balance < params.row.warn_threshold;
                return h('div',{
                  style:{
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'center',
                    gap: '6px',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    backgroundColor: isLow ? 'rgba(237, 64, 20, 0.1)' : 'transparent',
                    color: isLow ? '#ed4014' : '#515a6e',
                    fontWeight: isLow ? 'bold' : '500'
                  }
                },[
                  isLow ? h('Icon', {
                    props: { type: 'ios-warning', size: 16 },
                    style: { color: '#ed4014' }
                  }) : null,
                  h('span', params.row.warn_threshold.toLocaleString() + ' L'),
                  h('Button', {
                    props: { type: 'text', size: 'small', icon: 'ios-create' },
                    style: { color: '#2d8cf0' },
                    on: {
                      click:()=>{this.$set(params.row,'$isEditThreshold',true)}
                    }
                  })
                ])
              }
            }},
        ],
        oilRangeColumn:[
          {title: '排名', key: 'rank', width: 100, align: "center", render: (h, params) => {
            const rank = params.index + 1;
            let color = '#808695';
            let bgColor = '#f8f8f9';
            let icon = '';
            
            if (rank === 1) {
              color = '#fff';
              bgColor = '#ff9900';
              icon = '🥇';
            } else if (rank === 2) {
              color = '#fff';
              bgColor = '#a0a0a0';
              icon = '🥈';
            } else if (rank === 3) {
              color = '#fff';
              bgColor = '#cd7f32';
              icon = '🥉';
            }
            
            return h('div', {
              style: {
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '60px',
                height: '28px',
                borderRadius: '14px',
                backgroundColor: bgColor,
                color: color,
                fontWeight: 'bold',
                fontSize: '13px',
                boxShadow: rank <= 3 ? '0 2px 4px rgba(0,0,0,0.1)' : 'none'
              }
            }, rank <= 3 ? `${icon} ${rank}` : rank);
          }},
          {title: '油站名称', key: 'station_name', align: "left", minWidth: 150, render: (h, params) => {
            return h('div', {
              style: {
                display: 'flex',
                alignItems: 'center',
                fontWeight: params.index < 3 ? '600' : 'normal',
                color: params.index < 3 ? '#2d8cf0' : 'inherit',
                cursor: 'pointer'
              },
              on: {
                click: () => {
                  this.showStationCompanyList(params.row)
                }
              }
            }, [
              params.index < 3 ? h('Icon', {
                props: { type: 'ios-star', size: 14 },
                style: { color: '#ff9900', marginRight: '4px' }
              }) : null,
              h('span', params.row.station_name)
            ]);
          }},
          {title: '加油数量(L)', key: 'litre_num', align: "center", width: 180, sortable: 'custom', render: (h, params) => {
            // 计算最大值用于进度条
            const dataList = this.$refs.oilRangeTable ? this.$refs.oilRangeTable.dataLists : [];
            const maxLitre = dataList.length > 0 ? Math.max(...dataList.map(item => item.litre_num)) : 1;
            const percentage = Math.min((params.row.litre_num / maxLitre * 100), 100).toFixed(1);
            
            return h('div', {
              style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '6px'
              }
            }, [
              h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#19be6b',
                  fontSize: '15px'
                }
              }, params.row.litre_num.toLocaleString() + ' L'),
              h('Progress', {
                props: {
                  percent: parseFloat(percentage),
                  strokeColor: params.index === 0 ? '#ff9900' : params.index === 1 ? '#2d8cf0' : '#19be6b',
                  strokeWidth: 8,
                  hideInfo: true
                },
                style: { width: '100%' }
              })
            ]);
          }},
        ],
        companyOilRangeColumn:[
          {title: '排名', key: 'rank', width: 100, align: "center", render: (h, params) => {
            const rank = params.index + 1;
            let color = '#808695';
            let bgColor = '#f8f8f9';
            let icon = '';
            
            if (rank === 1) {
              color = '#fff';
              bgColor = '#ff9900';
              icon = '🥇';
            } else if (rank === 2) {
              color = '#fff';
              bgColor = '#a0a0a0';
              icon = '🥈';
            } else if (rank === 3) {
              color = '#fff';
              bgColor = '#cd7f32';
              icon = '🥉';
            }
            
            return h('div', {
              style: {
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '50px',
                height: '28px',
                borderRadius: '14px',
                backgroundColor: bgColor,
                color: color,
                fontWeight: 'bold',
                fontSize: '13px',
                boxShadow: rank <= 3 ? '0 2px 4px rgba(0,0,0,0.1)' : 'none'
              }
            }, rank <= 3 ? `${icon} ${rank}` : rank);
          }},
          {title: '车队名称', key: 'company_name', align: "left", minWidth: 150, render: (h, params) => {
            return h('div', {
              style: {
                display: 'flex',
                alignItems: 'center',
                fontWeight: params.index < 3 ? '600' : 'normal',
                color: params.index < 3 ? '#2d8cf0' : 'inherit',
                cursor: 'pointer'
              },
              on: {
                click: () => {
                  this.showCompanyStationList(params.row)
                }
              }
            }, [
              params.index < 3 ? h('Icon', {
                props: { type: 'ios-trophy', size: 14 },
                style: { color: '#2d8cf0', marginRight: '4px' }
              }) : null,
              h('span', params.row.company_name)
            ]);
          }},
          {title: '加油数量(L)', key: 'litre_num', align: "center", width: 180, sortable: 'custom', render: (h, params) => {
            // 计算最大值用于进度条
            const dataList = this.$refs.companyOilRangeTable ? this.$refs.companyOilRangeTable.dataLists : [];
            const maxLitre = dataList.length > 0 ? Math.max(...dataList.map(item => item.litre_num)) : 1;
            const percentage = Math.min((params.row.litre_num / maxLitre * 100), 100).toFixed(1);
            
            return h('div', {
              style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '6px'
              }
            }, [
              h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#2d8cf0',
                  fontSize: '15px'
                }
              }, params.row.litre_num.toLocaleString() + ' L'),
              h('Progress', {
                props: {
                  percent: parseFloat(percentage),
                  strokeColor: params.index === 0 ? '#ff9900' : params.index === 1 ? '#2d8cf0' : '#19be6b',
                  strokeWidth: 8,
                  hideInfo: true
                },
                style: { width: '100%' }
              })
            ]);
          }},
        ],
        oilRangeForm:{
          searchDay:'',
          sortKey: '',
          sortType: ''
        },
        companyOilRangeForm:{
          searchDay:'',
          sortKey: '',
          sortType: ''
        },
        dateOptions: {}
      }
    },
    computed:{
      // 订单趋势日均订单数（总订单数/天数）
      avgDailyOrder() {
        if (!this.trendSummary || !this.trendRangeDays) return 0;
        return (Number(this.trendSummary.order_num) / this.trendRangeDays).toFixed(1);
      },
      // 订单趋势日均加注量（总加注量/天数）
      avgDailyLitre() {
        if (!this.trendSummary || !this.trendRangeDays) return 0;
        return (Number(this.trendSummary.litre_num) / this.trendRangeDays).toFixed(1);
      },
      // 车队加油列表利润总和（优先接口 profit，否则（单价 - 站点价格）× 升数 前端计算）
      companyProfitTotal() {
        return this.companyListData.reduce((sum, item) => {
          const profit = parseFloat(item.profit);
          if (!isNaN(profit)) {
            return sum + profit;
          }
          const stationPrice = parseFloat(this.selectedStation && this.selectedStation.price);
          const companyPrice = parseFloat(item.price);
          const diff = (!isNaN(stationPrice) && !isNaN(companyPrice)) ? companyPrice - stationPrice : 0;
          return sum + diff * parseFloat(item.total_litre || 0);
        }, 0);
      },
      // 站点加油列表利润总和（优先接口 profit，否则（车队单价 - 站点单价）× 升数 前端计算）
      stationProfitTotal() {
        return this.stationListData.reduce((sum, item) => {
          const profit = parseFloat(item.profit);
          if (!isNaN(profit)) {
            return sum + profit;
          }
          const gasPrice = parseFloat(item.gas_price);
          const companyPrice = parseFloat(item.price);
          const diff = (!isNaN(gasPrice) && !isNaN(companyPrice)) ? companyPrice - gasPrice : 0;
          return sum + diff * parseFloat(item.total_litre || 0);
        }, 0);
      }
    },
    methods:{
      // 计算弹窗自适应尺寸：宽度占屏幕80%，表格最大高度适配屏幕
      calcModalSize() {
        const h = window.innerHeight || 800;
        // 表格最大高度 = 屏幕高度80% - 弹窗头部/信息条/表头/内边距等固定占用
        this.tableMaxHeight = Math.max(300, Math.floor(h * 0.9 - 260));
      },
      async getInfo(){
        let res = await this.$commonFun.postProxy('admin/count/home')
        this.info = res.data;
        this.group_id = res.data.group_id
        // 数据加载完成后，延迟初始化图表
        this.$nextTick(() => {
          setTimeout(() => {
            this.updateAllCharts();
          }, 500);
        });
      },
      turnToPage(name){
        this.$commonFun.jumpTo('',name)
      },
      // 跳转到今日订单
      goToTodayOrders() {
        const today = new Date()
        const year = today.getFullYear()
        const month = String(today.getMonth() + 1).padStart(2, '0')
        const day = String(today.getDate()).padStart(2, '0')
        const todayStr = `${year}-${month}-${day}`
        
        // 跳转到车队订单页面，并带上今天的日期参数
        this.$router.push({
          name: '车队订单',
          query: {
            create_time: todayStr
          }
        })
      },
      // 根据站点信息跳转到车队订单列表
      goToCompanyOrdersByStation(stationId, stationName) {
        const today = new Date()
        const year = today.getFullYear()
        const month = String(today.getMonth() + 1).padStart(2, '0')
        const day = String(today.getDate()).padStart(2, '0')
        const todayStr = `${year}-${month}-${day}`
        
        // 跳转到车队订单页面，带上站点ID和今天的日期参数
        this.$router.push({
          name: '车队订单',
          query: {
            station_id: stationId,
            create_time: todayStr
          }
        })
      },
      // 根据车队信息跳转到车队订单列表
      goToCompanyOrdersByCompany(companyId, companyName) {
        const today = new Date()
        const year = today.getFullYear()
        const month = String(today.getMonth() + 1).padStart(2, '0')
        const day = String(today.getDate()).padStart(2, '0')
        const todayStr = `${year}-${month}-${day}`
        
        // 跳转到车队订单页面，带上车队ID和今天的日期参数
        this.$router.push({
          name: '车队订单',
          query: {
            company_id: companyId,
            create_time: todayStr
          }
        })
      },
      // 滚动到站点库存监控
      scrollToStockMonitor() {
        // 查找站点库存监控的Card元素
        const stockMonitorCard = document.querySelector('.stock-monitor-card')
        if (stockMonitorCard) {
          // 平滑滚动到目标位置
          stockMonitorCard.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          })
          
          // 高亮效果（可选）
          stockMonitorCard.style.transition = 'box-shadow 0.3s ease'
          stockMonitorCard.style.boxShadow = '0 0 20px rgba(45, 140, 240, 0.6)'
          setTimeout(() => {
            stockMonitorCard.style.boxShadow = ''
          }, 2000)
        }
      },
      // 显示站点对应的车队列表
      async showStationCompanyList(station) {
        this.selectedStation = station;
        this.showCompanyModal = true;
        
        // 调用接口获取车队列表数据
        await this.getStationCompanyList(station);
      },
      // 获取站点下车队列表数据（独立方法）
      async getStationCompanyList(station) {
        this.companyListLoading = true;
        
        try {
          const res = await this.$commonFun.postProxy('admin/gas/stationCompanyList', {
            station_id: station.station_id,
            searchDay: this.oilRangeForm.searchDay || this.formatDate(new Date())
          });
          
          if (res.code === 200 && res.data && res.data.companies) {
            // 从 data.companies 中获取车队列表
            let companies = res.data.companies || [];
            
            // 按照加油量（total_litre）降序排序
            companies.sort((a, b) => {
              return parseFloat(b.total_litre) - parseFloat(a.total_litre);
            });
            
            this.companyListData = companies;
            
            // 更新 selectedStation 的价格信息（从接口返回的 data 中获取）
            if (res.data.price !== undefined) {
              this.$set(this.selectedStation, 'price', res.data.price);
            }
          } else {
            this.companyListData = [];
            this.$Message.warning(res.msg || '暂无数据');
          }
        } catch (error) {
          console.error('获取车队列表失败:', error);
          this.$Message.error('获取数据失败');
          this.companyListData = [];
        } finally {
          this.companyListLoading = false;
        }
      },
      // 显示车队对应的站点列表
      async showCompanyStationList(company) {
        this.selectedCompany = company;
        this.showStationModal = true;
        
        // 调用接口获取站点列表数据
        await this.getCompanyStationList(company);
      },
      // 获取车队下站点列表数据（独立方法）
      async getCompanyStationList(company) {
        this.stationListLoading = true;
        
        try {
          const res = await this.$commonFun.postProxy('admin/gas/companyStationList', {
            company_id: company.company_id,
            searchDay: this.companyOilRangeForm.searchDay || this.formatDate(new Date())
          });
          
          if (res.code === 200 && res.data && res.data.stations) {
            // 从 data.stations 中获取站点列表
            let stations = res.data.stations || [];
            
            // 按照加油量（total_litre）降序排序
            stations.sort((a, b) => {
              return parseFloat(b.total_litre) - parseFloat(a.total_litre);
            });
            
            this.stationListData = stations;
          } else {
            this.stationListData = [];
            this.$Message.warning(res.msg || '暂无数据');
          }
        } catch (error) {
          console.error('获取站点列表失败:', error);
          this.$Message.error('获取数据失败');
          this.stationListData = [];
        } finally {
          this.stationListLoading = false;
        }
      },
      // 格式化日期为 YYYY-MM-DD
      formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      getGrowthClass(rate){
        if (rate > 0) return 'positive';
        if (rate < 0) return 'negative';
        return 'neutral';
      },
      // 加油站排行排序
      oilRangeSortChange(data) {
        this.oilRangeForm.sortKey = data.key;
        this.oilRangeForm.sortType = data.order === 'asc' ? 'asc' : 'desc';
        this.$refs.oilRangeTable.searchAndResetPage();
      },
      // 车队加油排行排序
      companyOilRangeSortChange(data) {
        this.companyOilRangeForm.sortKey = data.key;
        this.companyOilRangeForm.sortType = data.order === 'asc' ? 'asc' : 'desc';
        this.$refs.companyOilRangeTable.searchAndResetPage();
      },
      // 计算低库存站点数量
      calculateLowStockCount() {
        if (this.$refs.stockStationTable && this.$refs.stockStationTable.dataLists) {
          this.lowStockCount = this.$refs.stockStationTable.dataLists.filter(
            item => item.litre_balance < item.warn_threshold
          ).length;
        }
      },
      async editLitreBalance(info){
        let res = await this.$commonFun.postProxy('admin/gas/editLitreBalance',{
          station_id: info.station_id,
          litre_balance: info.edit_litre_balance
        });
        this.$commonFun.dealApiResult(res, () => {
          this.$set(info, '$isEdit', false);
          this.$commonFun.successTip(res.msg || '修改成功');
          this.$refs.stockStationTable.getLists();
          setTimeout(() => this.calculateLowStockCount(), 300);
        });
      },
      async editWarnThreshold(info){
        let res = await this.$commonFun.postProxy('admin/gas/editWarnThreshold',{
          station_id: info.station_id,
          warn_threshold: info.warn_threshold
        });
        this.$commonFun.dealApiResult(res, () => {
          this.$set(info, '$isEditThreshold', false);
          this.$commonFun.successTip(res.msg || '修改成功');
          this.$refs.stockStationTable.getLists();
          setTimeout(() => this.calculateLowStockCount(), 300);
        });
      },
      // 初始化加油站排行饼图
      initOilRangeChart() {
        if (!this.$refs.oilRangeChart) {
          return;
        }
        
        const chart = echarts.init(this.$refs.oilRangeChart);
        // 优先使用表格数据，如果没有则使用模拟数据
        let allData = (this.$refs.oilRangeTable && this.$refs.oilRangeTable.dataLists) || [];
        
        //console.log('加油站排行数据总数:', allData.length); // 调试信息
        
        if (!allData || allData.length === 0) {
          allData = this.mockOilRangeData; // 使用模拟数据作为后备
        }
        
        // 处理数据：前10名单独显示，10名以后归为"其他"
        let chartData = [];
        if (allData.length > 0) {
          // 取前10名
          const top10 = allData.slice(0, 10);
          chartData = top10.map((item, index) => ({
            value: item.litre_num,
            name: item.station_name,
            station_id: item.station_id,
            itemStyle: {
              color: ['#ff9900', '#2d8cf0', '#19be6b', '#7367f0', '#faad14', '#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#ffeaa7'][index]
            }
          }));
          
          // 如果有超过10名的数据，将剩余的归为"其他"
          if (allData.length > 10) {
            const otherData = allData.slice(10);
            // 修复：确保数值类型转换后再累加
            const otherTotal = otherData.reduce((sum, item) => sum + parseFloat(item.litre_num || 0), 0);

            chartData.push({
              value: otherTotal,
              name: '其他',
              station_id: null,
              itemStyle: {
                color: '#dfe6e9'
              }
            });
          }

        }
        
        const option = {
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} L ({d}%)'
          },
          legend: {
            orient: 'horizontal', // 水平布局
            bottom: '0%', // 放在底部
            left: 'center',
            itemWidth: 16,
            itemHeight: 16,
            itemGap: 6, // 进一步缩小间距以容纳所有图例
            textStyle: { 
              fontSize: 10, // 进一步缩小字体以容纳更多图例
              padding: [0, 0, 0, 2]
            }
            // 移除 type: 'scroll'，让所有图例都直接展示出来
          },
          series: [
            {
              type: 'pie',
              radius: ['32%', '58%'], // 整体放大5%，适应较小高度
              center: ['50%', '38%'], // 稍微上移，给底部图例留更多空间
              avoidLabelOverlap: true,
              minAngle: 3, // 最小角度，确保小扇区可见
              itemStyle: {
                borderRadius: 8,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                show: true,
                formatter: function(params) {
                  // 显示完整的站点名称和百分比
                  let name = params.name;
                  return name + '\n' + params.percent.toFixed(1) + '%';
                },
                position: 'outside',
                distanceToLabelLine: 2,
                fontSize: 12, // 缩小标签字体
                lineHeight: 12 // 设置行高
              },
              labelLine: {
                length: 6, // 缩短引导线
                length2: 6,
                smooth: true
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 11,
                  fontWeight: 'bold'
                }
              },
              data: chartData
            }
          ]
        };
        
        chart.setOption(option);
        this.oilRangeChart = chart;
        
        // 添加点击事件，跳转到车队订单列表
        chart.on('click', (params) => {
          //console.log('饼图扇区被点击:', params);
          if (params.data && params.data.name && params.data.name !== '其他') {
            // 点击具体站点，跳转到该站点的车队订单列表
            //console.log('跳转到站点:', params.data.name, 'ID:', params.data.station_id);
            this.goToCompanyOrdersByStation(params.data.station_id, params.data.name);
          } else if (params.data && params.data.name === '其他') {
            // 点击"其他"区域，关闭当前打开的弹窗
            //console.log('点击"其他"，关闭弹窗');
            if (this.showModal) {
              this.showModal = false;
              this.$Message.info('已关闭车队加油列表');
            }
          }
        });
      },
      // 初始化车队排行柱状图
      initCompanyOilRangeChart() {
        if (!this.$refs.companyOilRangeChart) {
          return;
        }
        
        const chart = echarts.init(this.$refs.companyOilRangeChart);
        // 优先使用表格数据，如果没有则使用模拟数据
        let data = this.$refs.companyOilRangeTable && this.$refs.companyOilRangeTable.dataLists
          ? this.$refs.companyOilRangeTable.dataLists.slice(0, 10)
          : [];
        if (!data || data.length === 0) {
          data = this.mockCompanyRangeData;
        }
        
        const option = {
          title: {
            text: 'TOP10车队加油量对比',
            left: 'center',
            textStyle: { fontSize: 14, fontWeight: 600 }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '15%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: data.map(item => item.company_name),
            axisLabel: {
              interval: 0,
              rotate: 30,
              fontSize: 11
            }
          },
          yAxis: {
            type: 'value',
            name: '加油量(L)'
          },
          series: [
            {
              type: 'bar',
              data: data.map((item, index) => ({
                value: item.litre_num,
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: ['#ff9900', '#2d8cf0', '#19be6b'][index % 3] },
                    { offset: 1, color: ['#ffaa33', '#5ba3f5', '#52d48a'][index % 3] }
                  ])
                }
              })),
              barWidth: '60%',
              label: {
                show: true,
                position: 'top',
                fontSize: 11
              }
            }
          ]
        };
        
        chart.setOption(option);
        this.companyOilRangeChart = chart;
        
        // 添加点击事件，跳转到车队订单列表
        const self = this; // 保存 this 引用
        chart.on('click', function(params) {
          //console.log('柱状图被点击:', params);
          if (params.dataIndex !== undefined && self.$refs.companyOilRangeTable && self.$refs.companyOilRangeTable.dataLists) {
            const clickedCompany = self.$refs.companyOilRangeTable.dataLists[params.dataIndex];
            if (clickedCompany && clickedCompany.company_id) {
              //console.log('跳转到车队:', clickedCompany.company_name, 'ID:', clickedCompany.company_id);
              self.goToCompanyOrdersByCompany(clickedCompany.company_id, clickedCompany.company_name);
            } else {
              console.warn('未找到车队ID', clickedCompany);
            }
          }
        });
      },
      // 初始化库存状态分布图 - 饼图
      initStockTrendChart() {
        if (!this.$refs.stockTrendChart) {
          console.warn('库存状态分布图表容器不存在');
          return;
        }
        
        const chart = echarts.init(this.$refs.stockTrendChart);
        // 优先使用表格数据，如果没有则使用模拟数据
        let data = this.$refs.stockStationTable ? this.$refs.stockStationTable.dataLists : undefined;
        
        //console.log('库存状态分布 - 原始数据:', data ? data.length : '无数据');
        
        if (!data || data.length === 0) {
          data = this.mockStockData;
          //console.log('库存状态分布 - 使用模拟数据');
        }
        
        // 统计库存状态
        const normalCount = data.filter(item => item.litre_balance >= item.warn_threshold).length;
        const lowCount = data.filter(item => item.litre_balance < item.warn_threshold).length;
        const criticalCount = data.filter(item => item.litre_balance < item.warn_threshold * 0.5).length;
        
        //console.log('库存状态分布 - 正常:', normalCount, '低库存:', lowCount, '严重不足:', criticalCount);
        
        const option = {
          title: {
            text: '库存状态分布',
            left: 'center',
            textStyle: { fontSize: 14, fontWeight: 600 }
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c}个站点 ({d}%)'
          },
          legend: {
            orient: 'horizontal',
            bottom: '5%',
            left: 'center',
            itemWidth: 12,
            itemHeight: 12,
            itemGap: 15,
            textStyle: { 
              fontSize: 12,
              padding: [0, 0, 0, 5]
            }
          },
          series: [
            {
              type: 'pie',
              radius: '55%',
              center: ['50%', '45%'],
              avoidLabelOverlap: true,
              data: [
                { 
                  value: normalCount, 
                  name: '正常库存',
                  itemStyle: { color: '#19be6b' }
                },
                { 
                  value: lowCount - criticalCount, 
                  name: '低库存',
                  itemStyle: { color: '#ff9900' }
                },
                { 
                  value: criticalCount, 
                  name: '严重不足',
                  itemStyle: { color: '#ed4014' }
                }
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              label: {
                formatter: '{b}\n{c}个\n{d}%',
                position: 'outside',
                distanceToLabelLine: 5
              }
            }
          ]
        };
        
        chart.setOption(option);
        this.stockTrendChart = chart;
      },
      // 获取全部车队下拉选项（用于趋势图筛选）
      async getCompanyOptions() {
        let list = [];
        let page = 1;
        let total = 0;
        do {
          const res = await this.$commonFun.postProxy('admin/agent_data/getCompanySelect', { page: page, pagesize: 100 });
          if (!res || res.code !== 200 || !res.data) {
            break;
          }
          list = list.concat(res.data);
          total = res.count || list.length;
          page++;
        } while (list.length < total && page <= 50);
        this.companyOptions = list;
      },

      // 订单趋势
      async getTrend() {
        this.trendLoading = true;
        const params = {};
        // 日期范围（默认近7天）；未选择时兜底按近7天
        const range = this.trendDateRange || [];
        if (range.length === 2 && range[0] && range[1]) {
          const startStr = this.formatDateStr(range[0]);
          const endStr = this.formatDateStr(range[1]);
          if (startStr && endStr) {
            params.start_date = startStr;
            params.end_date = endStr;
          }
        }
        if (!params.start_date) {
          params.days = 7;
        }
        // 选择具体车队时，只统计该车队的趋势
        if (this.trendCompanyId) {
          params.company_id = this.trendCompanyId;
        }
        const res = await this.$commonFun.postProxy('admin/agent_data/getOrderTrend', params);
        this.trendLoading = false;
        if (res && res.code === 200 && res.data) {
          this.trendSummary = res.data.summary || null;
          this.trendRangeDays = res.data.days || 7; // 实际区间天数，用于日均计算
          this.$nextTick(() => {
            this.initTrendChart(res.data);
          });
        }
      },

      // 日期格式化为 yyyy-MM-dd（DatePicker 的 v-model 为 Date 对象）
      formatDateStr(date) {
        const d = new Date(date);
        if (isNaN(d.getTime())) return '';
        const m = ('0' + (d.getMonth() + 1)).slice(-2);
        const day = ('0' + d.getDate()).slice(-2);
        return d.getFullYear() + '-' + m + '-' + day;
      },

      // 订单趋势日期范围变化（含快捷选项点击）
      handleTrendDateChange(dates) {
        // dates 为格式化后的日期字符串数组，如 ['2026-10-01', '2026-10-07']
        if (dates && dates.length === 2 && dates[0] && dates[1]) {
          const diffDays = Math.round((new Date(dates[1]) - new Date(dates[0])) / 86400000) + 1;
          if (diffDays > 366) {
            this.$Message.warning('日期范围不能超过366天，请重新选择');
          } else {
            this.getTrend();
            return;
          }
        }
        // 清空或超出上限时：回退默认近7天，保持界面与查询一致
        const end = new Date();
        const start = new Date();
        start.setDate(start.getDate() - 6);
        this.trendDateRange = [start, end];
        this.getTrend();
      },

      initTrendChart(data) {
        if (!this.$refs.trendChart) {
          return;
        }
        if (this.trendChart) {
          this.trendChart.dispose();
        }
        this.trendChart = echarts.init(this.$refs.trendChart);
        const list = data.list || [];
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'cross' }
          },
          legend: {
            data: ['订单数', '加注量(L)', '金额(元)'],
            top: 10
          },
          grid: {
            left: '3%',
            right: '8%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            data: list.map(item => item.stat_date)
          },
          yAxis: [
            {
              type: 'value',
              name: '订单数',
              position: 'left',
              axisLine: { lineStyle: { color: '#2d8cf0' } }
            },
            {
              type: 'value',
              name: '加注量(L)',
              position: 'right',
              axisLine: { lineStyle: { color: '#19be6b' } }
            },
            {
              type: 'value',
              name: '金额(元)',
              position: 'right',
              offset: 60,
              axisLine: { lineStyle: { color: '#ff9900' } }
            }
          ],
          series: [
            {
              name: '订单数',
              type: 'bar',
              barMaxWidth: 24,
              data: list.map(item => item.order_num),
              itemStyle: { color: '#2d8cf0' }
            },
            {
              name: '加注量(L)',
              type: 'line',
              smooth: true,
              yAxisIndex: 1,
              data: list.map(item => item.litre_num),
              itemStyle: { color: '#19be6b' },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(25, 190, 107, 0.3)' },
                  { offset: 1, color: 'rgba(25, 190, 107, 0.05)' }
                ])
              }
            },
            {
              name: '金额(元)',
              type: 'line',
              smooth: true,
              yAxisIndex: 2,
              data: list.map(item => item.total_price),
              itemStyle: { color: '#ff9900' },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(255, 153, 0, 0.25)' },
                  { offset: 1, color: 'rgba(255, 153, 0, 0.05)' }
                ])
              }
            }
          ]
        };
        this.trendChart.setOption(option);
      },

      formatMoney(value) {
        return Number(value || 0).toFixed(2);
      },

      formatLitre(value) {
        return Number(value || 0).toFixed(1);
      },
      // 更新所有图表
      updateAllCharts() {
        this.$nextTick(() => {
          setTimeout(() => {
            // 检查表格数据是否已加载
            const oilData = this.$refs.oilRangeTable ? this.$refs.oilRangeTable.dataLists : undefined;
            const companyData = this.$refs.companyOilRangeTable ? this.$refs.companyOilRangeTable.dataLists : undefined;
            const stockData = this.$refs.stockStationTable ? this.$refs.stockStationTable.dataLists : undefined;
            
            // 只有当数据存在时才更新图表
            if (oilData && oilData.length > 0) {
              this.initOilRangeChart();
            }
            
            if (companyData && companyData.length > 0) {
              this.initCompanyOilRangeChart();
            }
            
            if (stockData && stockData.length > 0) {
              this.initStockTrendChart();
            }
            
            // 订单趋势图总是更新（因为它有自己的数据加载逻辑）
            this.getTrend();
          }, 300);
        });
      }

    },
    mounted(){
      // 计算弹窗自适应尺寸
      this.calcModalSize();
      window.addEventListener('resize', this.calcModalSize);
      // 监听表格数据变化，计算低库存数量
      this.$nextTick(() => {
        if (this.$refs.stockStationTable) {
          const originalGetLists = this.$refs.stockStationTable.getLists;
          this.$refs.stockStationTable.getLists = (...args) => {
            return originalGetLists.apply(this.$refs.stockStationTable, args).then(() => {
              this.calculateLowStockCount();
              // 延迟更新图表，确保数据已加载
              setTimeout(() => this.updateAllCharts(), 800);
            });
          };
        }
        
        // 为其他表格也添加图表更新
        if (this.$refs.oilRangeTable) {
          const originalOilGetLists = this.$refs.oilRangeTable.getLists;
          this.$refs.oilRangeTable.getLists = (...args) => {
            return originalOilGetLists.apply(this.$refs.oilRangeTable, args).then(() => {
              setTimeout(() => this.updateAllCharts(), 800);
            });
          };
        }
        
        if (this.$refs.companyOilRangeTable) {
          const originalCompanyGetLists = this.$refs.companyOilRangeTable.getLists;
          this.$refs.companyOilRangeTable.getLists = (...args) => {
            return originalCompanyGetLists.apply(this.$refs.companyOilRangeTable, args).then(() => {
              setTimeout(() => this.updateAllCharts(), 800);
            });
          };
        }
      });
    },
    created() {
      this.getInfo()
      this.getCompanyOptions()
    },
    beforeDestroy() {
      // 移除窗口尺寸监听
      window.removeEventListener('resize', this.calcModalSize);
      // 清除定时器
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = null;
      }
      
      // 销毁所有图表实例
      if (this.oilRangeChart) {
        this.oilRangeChart.dispose();
        this.oilRangeChart = null;
      }
      if (this.companyOilRangeChart) {
        this.companyOilRangeChart.dispose();
        this.companyOilRangeChart = null;
      }
      if (this.stockTrendChart) {
        this.stockTrendChart.dispose();
        this.stockTrendChart = null;
      }
      if (this.trendChart) {
        this.trendChart.dispose();
        this.trendChart = null;
      }
    }
  }
</script>

<style scoped lang="less">
// 统计卡片 - 现代化简洁风格
.stat-card {
  margin-bottom: 16px;
  transition: all 0.3s ease;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }
  
  /deep/ .ivu-card-body {
    padding: 24px;
  }
  
  .stat-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    
    .stat-value {
      font-size: 32px;
      font-weight: 700;
      color: #17233d;
      line-height: 1.2;
    }
    
    .stat-label {
      font-size: 14px;
      color: #808695;
      font-weight: 500;
    }
    
    .stat-yesterday {
      font-size: 12px;
      color: #808695;
      margin-top: 4px;
      
      .label {
        color: #808695;
      }
      
      .value {
        color: #515a6e;
        font-weight: 500;
      }
    }
    
    .stat-icon {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 48px;
      opacity: 0.15;
    }
  }
  
  // 不同颜色的卡片
  &.stat-blue {
    border-left: 4px solid #2d8cf0;
    .stat-icon { color: #2d8cf0; }
  }
  
  &.stat-green {
    border-left: 4px solid #19be6b;
    .stat-icon { color: #19be6b; }
  }
  
  &.stat-orange {
    border-left: 4px solid #ff9900;
    .stat-icon { color: #ff9900; }
  }
  
  &.stat-red {
    border-left: 4px solid #ed4014;
    .stat-icon { color: #ed4014; }
  }
  
  &.stat-purple {
    border-left: 4px solid #7367f0;
    .stat-icon { color: #7367f0; }
  }
  
  &.stat-cyan {
    border-left: 4px solid #00c5dc;
    .stat-icon { color: #00c5dc; }
  }
  
  &.stat-success {
    border-left: 4px solid #19be6b;
    .stat-icon { color: #19be6b; }
  }
  
  &.stat-warning {
    border-left: 4px solid #faad14;
    .stat-icon { color: #faad14; }
  }
}

// 排名列表卡片
.ranking-list-card {
  margin-bottom: 16px;
  border-radius: 8px;
  
  /deep/ .ivu-card-head {
    padding: 16px 20px;
    border-bottom: 2px solid #f0f0f0;
    background: linear-gradient(to right, #fafafa, #fff);
  }
  
  .card-title-with-badge {
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    .title-text {
      font-size: 16px;
      font-weight: 600;
      color: #17233d;
    }
  }
}

// 图表卡片
.chart-card {
  margin-bottom: 16px;
  border-radius: 8px;
  
  /deep/ .ivu-card-head {
    padding: 16px 20px;
    border-bottom: 2px solid #f0f0f0;
    background: linear-gradient(to right, #fafafa, #fff);
  }
  
  /deep/ .ivu-card-body {
    padding: 20px;
  }
  
  .card-title-with-badge {
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    .title-text {
      font-size: 16px;
      font-weight: 600;
      color: #17233d;
    }
    
    .trend-filters {
      display: flex;
      gap: 10px;
    }
  }
  
  // 图表容器 - 与表格高度对齐
  .chart-container {
    width: 100%;
    min-height: 400px; // 最小高度确保内容可见
    height: auto; // 自适应高度
    aspect-ratio: 1 / 1.2; // 保持宽高比，约为正方形稍高
  }
}

// 订单趋势汇总卡片
.trend-summary {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  padding: 16px;
  background: #f8f8f9;
  border-radius: 4px;

  .trend-summary-item {
    flex: 1;
    text-align: center;
    padding: 12px;
    background: white;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

    .ts-label {
      font-size: 12px;
      color: #8c8c8c;
      margin-bottom: 8px;
    }

    .ts-value {
      font-size: 24px;
      font-weight: bold;
    }

    .ts-blue { color: #2d8cf0; }
    .ts-green { color: #19be6b; }
    .ts-orange { color: #ff9900; }
    .ts-purple { color: #7367f0; }

    .ts-split {
      margin: 0 4px;
      font-size: 14px;
      color: #8c8c8c;
    }
  }
}

// 库存监控卡片
.stock-monitor-card {
  margin-bottom: 16px;
  border-radius: 8px;
  
  /deep/ .ivu-card-head {
    padding: 16px 20px;
    border-bottom: 2px solid #19be6b;
    background: linear-gradient(to right, #f0faf5, #fff);
  }
  
  .card-title-with-badge {
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    .title-text {
      font-size: 16px;
      font-weight: 600;
      color: #17233d;
    }
  }
}
</style>
